"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeAsset = exports.XrplClient = exports.binary = exports.XrplDefinitions = exports.rawSigning = exports.utils = exports.signAndSubmit = exports.sign = exports.derive = exports.generate = exports.XRPL_Account = void 0;
/* Methods  ==================================================================== */
var generate = __importStar(require("./generate"));
exports.generate = generate;
var derive = __importStar(require("./derive"));
exports.derive = derive;
var utils = __importStar(require("./utils"));
exports.utils = utils;
var sign_1 = require("./sign");
Object.defineProperty(exports, "sign", { enumerable: true, get: function () { return sign_1.sign; } });
Object.defineProperty(exports, "signAndSubmit", { enumerable: true, get: function () { return sign_1.signAndSubmit; } });
var rawSigning = __importStar(require("./rawSigning"));
exports.rawSigning = rawSigning;
/* Types ==================================================================== */
var Account_1 = __importDefault(require("./schema/Account"));
exports.XRPL_Account = Account_1.default;
/* Client ==================================================================== */
var xrpl_client_1 = require("xrpl-client");
Object.defineProperty(exports, "XrplClient", { enumerable: true, get: function () { return xrpl_client_1.XrplClient; } });
/* Defs ==================================================================== */
var ripple_binary_codec_1 = require("ripple-binary-codec");
Object.defineProperty(exports, "XrplDefinitions", { enumerable: true, get: function () { return ripple_binary_codec_1.XrplDefinitions; } });
Object.defineProperty(exports, "nativeAsset", { enumerable: true, get: function () { return ripple_binary_codec_1.nativeAsset; } });
var binary = {
    encode: ripple_binary_codec_1.encode,
    decode: ripple_binary_codec_1.decode,
    encodeForSigning: ripple_binary_codec_1.encodeForSigning,
    encodeForMultisigning: ripple_binary_codec_1.encodeForMultisigning,
    encodeForSigningClaim: ripple_binary_codec_1.encodeForSigningClaim,
};
exports.binary = binary;
